import { render, staticRenderFns } from "./ConnectInstagram.vue?vue&type=template&id=53ea62c5"
import script from "./ConnectInstagram.vue?vue&type=script&lang=js"
export * from "./ConnectInstagram.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports